module.exports = __webpack_public_path__ + "static/media/House-of-Aama-Fashion-Design.af80c405.png";